import { Keyframe, WeightedMode } from "./Keyframe";
import { Vector3 } from "./Vector3";
export class Vector3Keyframe extends Keyframe {
    constructor(weightMode = false) {
        super();
        this.inTangent = new Vector3();
        this.outTangent = new Vector3();
        this.value = new Vector3();
        if (weightMode) {
            this.inWeight = new Vector3(Keyframe.defaultWeight, Keyframe.defaultWeight, Keyframe.defaultWeight);
            this.outWeight = new Vector3(Keyframe.defaultWeight, Keyframe.defaultWeight, Keyframe.defaultWeight);
            this.weightedMode = new Vector3(WeightedMode.None, WeightedMode.None, WeightedMode.None);
        }
    }
    cloneTo(dest) {
        super.cloneTo(dest);
        this.inTangent.cloneTo(dest.inTangent);
        this.outTangent.cloneTo(dest.outTangent);
        this.value.cloneTo(dest.value);
        if (this.weightedMode) {
            this.inWeight.cloneTo(dest.inWeight);
            this.outWeight.cloneTo(dest.outWeight);
            this.weightedMode.cloneTo(dest.weightedMode);
        }
    }
}
